import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
    FaMobileAlt
} from "react-icons/fa";
import { AiOutlineUserAdd } from "react-icons/ai";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { TfiPackage } from "react-icons/tfi";
import { FiLock } from "react-icons/fi";
import { HiOutlineRocketLaunch } from "react-icons/hi2";
import { RiSecurePaymentLine } from "react-icons/ri";

import "./StartStore.scss";

const StartaButik = () => {
    return (
        <div className="starta-page">
            <div className="starta-wrapper">
                <Container>
                    <h2 className="page-title text-center">
                        Så startar du din butik
                    </h2>

                    <Row className="g-4 mt-4">

                        {/* Steg 1 */}
                        <Col md={4}>
                            <Card className="step-card">
                                <TfiPackage className="step-icon" />

                                <div className="card-content">
                                    <h5>1. Välj paket</h5>
                                    <p>
                                        Välj det abonnemang som passar din butik bäst.
                                    </p>
                                </div>
                            </Card>
                        </Col>

                        {/* Steg 2 */}
                        <Col md={4}>
                            <Card className="step-card">
                                <AiOutlineUserAdd className="step-icon" />


                                <div className="card-content">
                                    <h5>2. Registrera dig</h5>
                                    <p>
                                        Klicka på "Välj paket" och skapa ditt konto.
                                    </p>
                                </div>

                                <Button
                                    as={Link}
                                    to="/Pris"
                                    className="step-button"
                                >
                                    Se abonnemang
                                </Button>
                            </Card>
                        </Col>

                        {/* Steg 3 */}
                        <Col md={4}>
                            <Card className="step-card">
                                <RiSecurePaymentLine className="step-icon" />

                                <div className="card-content">
                                    <h5>3. Skaffa Swish Handel</h5>
                                    <p>
                                        Ange Närbutik som teknisk kontakt.
                                    </p>
                                </div>
                            </Card>
                        </Col>

                        {/* Steg 4 */}
                        <Col md={4}>
                            <Card className="step-card">
                                <FiLock className="step-icon" />


                                <div className="card-content">
                                    <h5>4. Installera lås eller kyl</h5>
                                    <p>
                                        Installera digitalt lås eller kylskåp i din butik.
                                    </p>
                                </div>
                            </Card>
                        </Col>

                        {/* Steg 5 */}
                        <Col md={4}>
                            <Card className="step-card">
                                <HiOutlineRocketLaunch className="step-icon" />

                                <div className="card-content">
                                    <h5>5. Öppna butiken</h5>
                                    <p>
                                        Nu är du redo att ta emot dina första kunder.
                                    </p>
                                </div>
                            </Card>
                        </Col>

                        {/* SISTA ORANGE KORTET */}
                        <Col md={4}>
                            <Card className="step-card final-card">
                                <IoMdCheckmarkCircleOutline className="step-icon" />

                                <div className="card-content">
                                    <h5>KLART!</h5>
                                    <p>
                                        Din Närbutik är nu igång och redo för framtiden.
                                    </p>
                                </div>
                            </Card>
                        </Col>

                    </Row>
                </Container>
            </div>
        </div>
    );
};

export default StartaButik;